
export const environment = {
  production: true,
  apiUrl: "/register/api",
  cabinetApiUrl: "/lk/api",
  apiUrlConfig: "/config",
  assetsPath: "/register/",
  gtmPath: "/made",
  gtmTag: {'default': 'GTM_TAG_IS_NOT_FOUND_IN_DB', 'base': 'GTM-5MMB3JN'},
  gtmId: "GTM-MX83FG9",
  brand: "VIVUS",
  openCabinetUrlInNewContext: false,
  dadataSuggestionUrl: "https://suggestions.dadata.ru/suggestions/api/4_1/rs",
  dadataToken: "85c82308f58161b9b05541c43ac1cb5255ede07a",
  scripts: ['https://consultsystems.ru/script/26590/'],
  googleAnalyticsId: "UA-35783582-1",
  yandexMapKey: "{{ vault_ecd_frontend_vivus_ya_maps_key }}",
  yandexMetrikaId: "26443950",
  yandexMetrikaIdI: "undefined",
  mailRuId: "2716016",
  version: "v2",
  imageUploadService: "/adddocs",
  equifaxPartnerId: "2759",
  captchaKey: "6LeZzoIpAAAAAHl9R0fITurkF0Uu0TLD21pN5ekW",
  juicyApiKey: "mQoCSee30x3Peqpe19D0Ky1X",
};
